import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'

import MainContainer3 from '../../components/Carousel/MainContainer3'
import { useParams } from 'react-router-dom'
import BannerConciergerie from '../../components/Servicepages/BannerConciergerie'
import ServicePageConcierge from '../../components/Servicepages/ServicePageConcierge'


const Conciergerie = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
   const { titre } = useParams();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >

      <Header />
      <BannerConciergerie titre={titre} />

      <ServicePageConcierge titre={titre} />
     

     
      <Footer />
    </motion.div>
  )
}

export default Conciergerie
